import SkeletonShippinGroupDetail from "components/Commons/Skeleton/SkeletonShippinGroupDetail"
import SummaryProductList from "components/Contractor/OrderDetail/SummaryProducts/SummaryProductsList"
import OrderDetailHOC from "hoc/OrderDetailHOC"
import { OrderDetailType } from "types/OrderType"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import { GlobalContext } from "context/context/GlobalContext"
import { useContext } from "react"

const ContractorReceptionOtherScreen = ({ shippinGroupDetail, shippingGroupId, order }: OrderDetailType) => {
  const { errorHander } = useContext(GlobalContext)

  const itemsOrder = shippinGroupDetail?.source.items

  return (
    <>
      {errorHander?.state?.hasError ? (
        <ErrorHandler 
          code={errorHander.state.code} 
          message={errorHander.state.message || "Ha ocurrido un error inesperado"} 
        />
      ) : itemsOrder ? (
        <>
          <SummaryProductList
            itemsOrder={itemsOrder}
            groupPicking={false}
            titleMain={"Productos entregados"}
          />
        </>
      ) : (
        <SkeletonShippinGroupDetail />
      )}
    </>
  )
}

export default OrderDetailHOC(ContractorReceptionOtherScreen)
